import {planTypes, trackingPlanTypes} from "@/common/constants";
import {get} from "lodash";

const supportCapacity = [500, 1000];
if (window.newBillingConfig?.enableLargeMeeting3k5k) {
  supportCapacity.push(3000, 5000);
}

export default {
  key: planTypes['large_meeting'],
  data () {
    return {
      logo: require('@/assets/plans/large_meeting.svg'),
      title: this.$t('billing.large_meeting.title'),
      subtitle: '',
      capacityKey: 'capacity',
      planType: planTypes.LARGE_MEETING,
      description: window.newBillingConfig?.enableLargeMeeting3k5k ? this.$t('billing.large_meeting.desc_new') : this.$t('billing.large_meeting.desc'),
      totalLimitDesc: this.$t('billing.licences_limit_tips', ['Large Meeting', 'Zoom One']),
      configDescription: window.newBillingConfig?.enableLargeMeeting3k5k ? this.$t('billing.large_meeting.config_desc_new') : this.$t('billing.large_meeting.config_desc'),
      supportCapacity: supportCapacity,
      capacityUnitI18nKey: 'billing.participants',
    }
  },
  computed: {
    trackingPlanKey() {
      return get(trackingPlanTypes, get(planTypes, this.planType));
    },
  }
};
